import { ORDERS } from "../../actions/type";

export default function orders(state = [], action) {
    switch (action.type) {
        case ORDERS:
            return action.payload;;
        default:
            return state
    }
}